import { capitalize, ceil, floor } from "lodash";

export function truncateMiddle(value: string | undefined, maxLength: number = 23, separator = "...") {
  if (!value) return value;
  if (value.length <= maxLength) return value;
  const segment1 = value.slice(0, ceil(maxLength / 2 - ceil(separator.length / 2)));
  const segment2 = value.slice(value.length - floor(maxLength / 2 - floor(separator.length / 2)));
  return `${segment1}${separator}${segment2}`;
}

export function truncateEnd(value: string | undefined, maxLength: number = 32, ending = "...") {
  if (!value) return value;
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength - 1)}${ending}`;
}

// Mirror of config/initializers/inflections.rb. Keep in sync when adding
// acronyms on the Rails side — they affect any titleized slug/role label.
const ACRONYMS = new Set(["api", "oauth", "oidc", "saml", "scim", "sso", "ai", "it", "mcp", "uuid"]);

export function titleize(str: string) {
  return str
    ?.split("_")
    .map((c) => (ACRONYMS.has(c.toLowerCase()) ? c.toUpperCase() : capitalize(c)))
    .join(" ");
}

// Title-case a space-separated string (e.g. "PEOPLE TEAM" -> "People Team"). Unlike
// titleize, splits on spaces rather than underscores and does not expand acronyms.
export function titleCase(str: string | undefined): string | undefined {
  return str
    ?.split(" ")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
}

export function pluralize(singular: string, count: number, plural?: string): string {
  return count === 1 ? singular : plural || `${singular}s`;
}

export function toPrefixId(resource: string, id: string) {
  return `${resource}_${id}`;
}

export function userRoleEmailId(
  emailAddress?: string,
  recordType?: string,
  recordId?: string,
  emailType?: "personal" | "work",
) {
  if (emailAddress) {
    return emailAddress;
  }
  return `${toPrefixId(recordType as string, recordId as string)}-${emailType ?? "work"}`;
}
